/* ***************************************************************** */
/* TODO: eslint pre-existing exceptions auto generated on 2022-09-08 */
/*       Do not add to these rule exceptions. Only remove as the     */
/*       violations are cleaned from our code.                       */
/*                                                                   */
/*       eslint-disable no-use-before-define                         */
/*       eslint-disable no-unused-expressions                        */
/*       eslint-disable react-hooks/exhaustive-deps                  */
/* ***************************************************************** */

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions, selectors } from '../../store/dux/nrx-dux';
import { selectors as fieldSelectors } from '../../store/dux/fields-dux';
import { selectors as growerSelectors } from '../../store/dux/grower-dux';
import ResizablePanel from '../../components/Resizeable/ResizablePanel';
import NrxMap from './NrxMap';
import FieldNrx from './components/FieldNrx';
import { Section } from '../Section';

export default function Nrx() {
  const dispatch = useDispatch();
  const fields = useSelector(selectors.fields);
  const growerId = useSelector(growerSelectors.selectedId);
  const isLoading = useSelector(selectors.isLoading);
  const selectedFields = useSelector(fieldSelectors.selectedFields);

  useEffect(() => {
    reloadFields();
  }, [growerId]);

  const reloadFields = () => {
    growerId && dispatch(actions.loadNrxForGrower(growerId));
  };

  return (
    <Section>
      <ResizablePanel
        topPanel={<NrxMap />}
        bottomPanel={
          <FieldNrx
            isLoading={isLoading}
            fields={fields}
            selectedFields={selectedFields}
            reloadFields={reloadFields}
          />
        }
      />
    </Section>
  );
}
